import { useState, useEffect } from 'react';
import { Message } from './useAuthForm';

export function useHashError() {
  const [hashMessage, setHashMessage] = useState<Message>(null);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.startsWith('#error=')) {
      const params = new URLSearchParams(hash.substring(1));
      const errorDescription = params.get('error_description');
      if (errorDescription) {
        let message = decodeURIComponent(errorDescription).replace(/\+/g, ' ');
        // Replace Supabase's generic banned message with a friendlier one
        if (message.toLowerCase().includes('user is banned')) {
          message =
            'Your account is currently unavailable, please get in touch with support@jua.ai';
        }
        setHashMessage({
          text: message,
          type: 'warn',
        });
        // Clean up the URL without triggering a re-render
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }
  }, []); // Run once on mount

  return hashMessage;
}
